import { useExchangeRates } from '@components/ExchangeRatesProvider'
import { currenciesList } from '@velasca/constants'
import { useCountry } from '@velasca/hooks/use-country'
import { WorldIcon } from '@velasca/icons/world'
import type { MiscHeaderData } from '@velasca/types'
import { formatCurrencies } from '@velasca/utils/format-currencies'
import { $settings } from '@velasca/utils/globals'
import { SWITCH_COUNTRY_PLACEHOLDER } from '../MobileNavigation'
import {
  ArrowTop,
  CountryLowerMenuListItem,
  Link,
  LowerMenuCurrencySwitch,
  LowerMenuIconWrapper,
  LowerMenuTitle,
} from '../MobileNavigation.styles'

interface CountrySwitchLowerMenuItemProps {
  miscHeaderData: MiscHeaderData
  openSwitchCountry?: () => void
  openSwitchCurrency?: () => void
}

export const CountrySwitchLowerMenuItem = ({
  miscHeaderData,
  openSwitchCountry,
  openSwitchCurrency,
}: CountrySwitchLowerMenuItemProps) => {
  const { currency } = useExchangeRates()
  const currencies = formatCurrencies(currenciesList, $settings.language)
  const currencyData = currencies.find((c) => c.code === currency)
  const country = useCountry()

  if (!country) {
    return null
  }

  const link = miscHeaderData.liquidLinks?.find(
    (liquidLink) => liquidLink.placeholder === SWITCH_COUNTRY_PLACEHOLDER,
  )
  const url = link ? link.value : (miscHeaderData.switchCountryPage ?? '#')

  return (
    <CountryLowerMenuListItem>
      <Link
        href={url}
        onClick={(e) => {
          if (openSwitchCountry) {
            e.preventDefault()
            openSwitchCountry()
          }
        }}
      >
        <LowerMenuTitle>
          <LowerMenuIconWrapper>
            <WorldIcon />
          </LowerMenuIconWrapper>
          <span className="text">
            {country.label}{' '}
            {$settings.language ? `(${$settings.language?.toUpperCase()})` : ''}
          </span>
          <ArrowTop />
        </LowerMenuTitle>
      </Link>
      {miscHeaderData?.currency?.supported && (
        <LowerMenuCurrencySwitch onClick={openSwitchCurrency}>
          <LowerMenuTitle>
            {currencyData ? (
              <span className="text">
                {currencyData.symbol} ({currencyData.code})
              </span>
            ) : (
              <span className="text">{currency}</span>
            )}
            <ArrowTop />
          </LowerMenuTitle>
        </LowerMenuCurrencySwitch>
      )}
    </CountryLowerMenuListItem>
  )
}
